import React, { useEffect } from 'react';

const FeedbackForm = ({
  showForm,
  feedbackText,
  setFeedbackText,
  feedbackScreenshot,
  isSubmitting,
  isTakingScreenshot,
  onSubmit,
  onCancel,
  onClose,
  onScreenshotUpload,
  onTakeScreenshot,
  feedbackFormRef,
  messageId
}) => {
  useEffect(() => {
    if (!showForm || !onClose) return;
    const handleClickOutside = (e) => {
      if (feedbackFormRef?.current && !feedbackFormRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showForm, onClose, feedbackFormRef]);

  if (!showForm) return null;

  return (
    <div
      ref={feedbackFormRef}
      className="negative-feedback-form"
    >
      <button
        type="button"
        className="negative-feedback-close-btn"
        onClick={onClose}
        aria-label="Close feedback form"
        title="Close"
      >
        ×
      </button>
      <div className="mb-3">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          What went wrong?
        </label>
        <textarea
          value={feedbackText}
          onChange={(e) => setFeedbackText(e.target.value)}
          placeholder="Please describe what could be improved..."
          className="w-full p-3 border border-gray-300 dark:border-[#444444] rounded-xl bg-white dark:bg-[#1a1a1a] text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-black dark:focus:ring-white focus:border-transparent resize-vertical min-h-[80px]"
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Add screenshot (optional)
        </label>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onTakeScreenshot}
            disabled={isTakingScreenshot}
            className="screenshot-button"
          >
            {isTakingScreenshot ? 'Capturing...' : 'Take Screenshot'}
          </button>
          <input
            type="file"
            accept="image/*"
            onChange={onScreenshotUpload}
            className="hidden"
            id={`screenshot-upload-${messageId}`}
          />
          <label
            htmlFor={`screenshot-upload-${messageId}`}
            className="upload-label"
          >
            {feedbackScreenshot ? 'Change' : 'Upload'}
          </label>
          {feedbackScreenshot && (
            <span className="text-sm text-gray-600 dark:text-gray-400">
              {feedbackScreenshot.name}
            </span>
          )}
        </div>
      </div>
      
      <div className="button-container">
        <button
          onClick={onCancel}
          className="cancel-button px-4 rounded-xl"
        >
          I'd rather not
        </button>
        <button
          onClick={onSubmit}
          disabled={isSubmitting || (!feedbackText.trim() && !feedbackScreenshot)}
          className="submit-button px-4 rounded-xl"
        >
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </div>
  );
};

export default FeedbackForm; 